import Masked from './Masked';

interface CaseRefProps {
  /** The complaint/case reference, e.g. `complaint.reference`. */
  value?: string | null;
}

/**
 * Masked complaint/case reference value (Medallia DXA PII masking, CD-8245).
 *
 * Renders the reference as a masked `<span>` — a drop-in replacement for a
 * plain `{complaint.reference}` text node at call sites such as the
 * SubmissionFlow header banner and the change-company modal title.
 */
export function CaseRef({ value }: CaseRefProps) {
  return <Masked>{value}</Masked>;
}

export default CaseRef;
